import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";

@Component({
  selector: 'app-calendly-modal',
  standalone: true,
  imports: [CommonModule],
  template: `
  <div class="backdrop" *ngIf="open" (click)="close()"></div>

  <div class="modal" *ngIf="open" role="dialog" aria-modal="true" aria-label="Calendly">
    <div class="modal__top">
      <div class="title">Réserver un appel</div>
      <button class="x" type="button" (click)="close()" aria-label="Fermer">✕</button>
    </div>

    <iframe class="frame" [src]="safeUrl" loading="lazy"></iframe>
    <div class="modal__bottom">
      <a class="btn ghost" [href]="url" target="_blank" rel="noreferrer">Ouvrir dans un onglet</a>
      <button class="btn primary" type="button" (click)="close()">Terminé</button>
    </div>
  </div>
  `,
  styles: [`
    .backdrop{
      position: fixed; inset:0; z-index:1000;
      background: rgba(0,0,0,.55);
    }
    .modal{
      position: fixed; inset: 5vh 6vw auto 6vw;
      height: 90vh;
      z-index:1001;
      border-radius: 22px;
      border: 1px solid rgba(255,255,255,.12);
      background: rgba(7,11,23,.92);
      backdrop-filter: blur(12px);
      box-shadow: 0 40px 120px rgba(0,0,0,.60);
      overflow:hidden;
      display:flex; flex-direction:column;
    }
    .modal__top{
      display:flex; align-items:center; justify-content:space-between;
      padding: 12px 14px;
      border-bottom: 1px solid rgba(255,255,255,.10);
    }
    .title{ font-weight: 900; }
    .x{
      width:40px; height:40px;
      border-radius: 14px;
      border: 1px solid rgba(255,255,255,.12);
      background: rgba(255,255,255,.06);
      color: rgba(235,240,255,.92);
      cursor:pointer;
    }
    .frame{ border:0; width:100%; flex:1; background:#fff; }
    .modal__bottom{
      display:flex; justify-content:flex-end; gap:10px;
      padding: 12px 14px;
      border-top: 1px solid rgba(255,255,255,.10);
    }
    @media (max-width: 860px){
      .modal{ inset: 6vh 10px auto 10px; height: 88vh; }
    }
  `]
})
export class CalendlyModalComponent {
  @Input() open = false;
  @Input() url = '';
  @Output() closed = new EventEmitter<void>();

  constructor(private sanitizer: DomSanitizer) {}

  get safeUrl(): SafeResourceUrl | null {
    if (!this.url) return null;

    const finalUrl = this.url.includes('?')
        ? `${this.url}&hide_gdpr_banner=1`
        : `${this.url}?hide_gdpr_banner=1`;

    return this.sanitizer.bypassSecurityTrustResourceUrl(finalUrl);
  }

  close(): void {
    this.closed.emit();
  }
}
